<template>
  <div id="app" ref="app">
    <router-view />
  </div>
</template>
<script>
export default {
  mounted(){
    window.appCont = this.$refs.app
    window.vue_this = this
  }
};
</script>



// WEBPACK FOOTER //
// src/App.vue